export default {
  businesDepartment: {
    businesList: {
      companyDepartment: '公司/部门',
      company: '公司',
      department: '部门',
      planWeek: '计划周期',
      year: '年度',
      month: '月份',
      planStartDate: '计划开始日期',
      planStartDateStart: '计划开始日期起',
      planStartDateEnd: '计划开始日期止',
      planEndDate: '计划结束日期',
      planEndDateStart: '计划结束日期起',
      planEndDateEnd: '计划结束日期止',
      productName: '物料',
      cashType: '款项类型',
      partnerName: '合作伙伴',
      quantity: '数量',
      unitPrice: '单价',
      paymentType: '收付方式',
      receiveAmount: '收款金额',
      payAmount: '付款金额',
      paymentDate: '收付日期',
      currencyType: '币别',
      inputPerson: '填写人',
      mark: '备注',
      companyValidRules: '请选择公司',
      departmentValidRules: '请选择部门',
      yearValidRules: '请选择年度',
      monthValidRules: '请选择月份',
      planCycleValidRules: '请选择计划周期',
      planStartDateValidRules: '请选择计划开始日期',
      planEndDateValidRules: '请选择计划结束日期',
      paymentTypeValidRules: '请选择收货方式',
      currencyTypeValidRules: '请选择币别',
      quantityValidRules: '请输入数量',
      receiveAmountValidRules: '请输入收款金额',
      payAmountValidRules: '请输入付款金额',
      currencyTypeRules: '请输入币别',
      toSafeguardDepartment: '资金计划维修-业务部',
      safeguardDepartment: '资金计划业务部',
      selectOnechangeEdit: '请选择一条数据进行修改',
      pleaseChangeDelete: '请选择要删除的数据',
      noSaveMates: '暂无需要保存的数据',
      planDayHasAdd: '日计划，自定义计划收付日期必填',
      planMonthHasAdd: '月计划，半月计划收付日期必不填',
      noMatasToExport: '没有能够导出的数据',
      add: '新增',
      copy: '复制',
      delete: '删除',
      save: '保存',
      upLoade: '批量导入',
      exportError: '导入失败',
      exportSuccess: '导入成功',
      forbidden: '禁用',
      mon: '月',
      selectFinancing: '请选择融资品种',
      selectFinancingStatus: '请选择融资状态',
      selectNatureLetterCredit: '请选择信用证性质',
      selectFinancingBank: '请选择融资银行',
    },
    financing: {
      planCycle: '计划周期',
      financeVariety: '融资品种',
      financeStatus: '融资状态',
      creditForm: '信用证性质',
      financeBank: '融资银行',
      invalidDate: '到期日',
      creditNo: '编号(信用证号等)',
      amount: '金额（万）',
      currency: '币别',
      cashResource: '资金来源',
      planStartDateStart: '计划开始日期起',
      planStartDateEnd: '计划开始日期止',
      planEndDateStart: '计划结束日期起',
      planEndDateEnd: '计划结束日期止',
      financeVarietyValidRules: '请选择融资品种',
      financeStatusValidRules: '请选择融资状态',
      creditFormValidRules: '请选择信用证性质',
      financeBankValidRules: '请选择融资银行',
      currencyValidRules: '请选择币别',
      tpSafeguardFinancing: '资金计划维修-表外融资',
      safeguardFinancing: '资金计划表外融资',
      pleaseChangetoTalMatas: '请选择要合计的数据',
      noChangetoTalMatas: '暂无数据进行合并',
      differentCompany: '请选择同一家公司的数据进行操作',
      differentDepartment: '请选择同一部门的数据进行操作',
      differentFinanceVariety: '请选择同一融资品种的数据进行操作',
      differentCreditForm: '请选择同一信用证性质的数据进行操作',
      differentCurrency: '请选择同一币别的数据进行操作',
      toTal: '合计',
    },
    tradeFinance: {
      receiveDate: '收款日期',
      payDate: '付款日期',
      planDays: '天数',
      interestRate: '利率(%)',
      planInterest: '利息',
      toSafeguardTradeFinancing: '资金计划维修-贸易融资和内部往来',
      safeguardTradeFinancing: '资金计划-贸易融资和内部往来',
      planStartDateStart: '计划开始日期起',
      planStartDateEnd: '计划开始日期止',
      planEndDateStart: '计划结束日期起',
      planEndDateEnd: '计划结束日期止',
    },
    message: {
      dateError: '结束日期不能小于开始日期',
      receiveAmount: '收款金额必填',
      payAmount: '付款金额必填',
      amount: '金额必填',
      hmpOrCpEmpty: '半月计划和自定义计划则计划开始日期和计划结束日期必填',
      noData: '请选择需要复制的数据',
    },
  },
};
